// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202512121203/js/" + chunkId + "." + {"44":"f07b83bf","225":"dbd35745","481":"fd189da6","486":"7935290a","770":"d59e8955"}[chunkId] + ".0.04725783551647367.chunk.js";
};